const TextReassu = () => {
  return (
    <div className="text reassu">
      <span><b>❤️ 4,8/5 de satisfaction</b> sur + de 300 avis clients</span>
      <span><b>🔧 5 237 installations réalisées</b> dans le Grand Ouest et donc forcément une près de chez vous !</span>
    </div>
  );
}

export default TextReassu;